import React, { useEffect, useState, useCallback } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import api from "../../utils/api";

const Payment = () => {
  const { merchantTransactionId } = useParams(); // optional param
  const [searchParams] = useSearchParams();      // PhonePe query params
  const navigate = useNavigate();

  const [status, setStatus] = useState("CHECKING"); // CHECKING | SUCCESS | FAILED | PENDING
  const [loading, setLoading] = useState(true);

  const userId = localStorage.getItem("userId");

  /* ================= CHECK PAYMENT ================= */

  const checkPayment = useCallback(async () => {
    try {
      setLoading(true);

      // Priority: URL param → query param
      const txnId =
        merchantTransactionId ||
        searchParams.get("merchantTransactionId");

      if (!txnId) {
        setStatus("FAILED");
        return;
      }

      const res = await api.get(`/api/payment/status/${txnId}`);

      const paymentStatus = res.data?.status;
      const orderId = res.data?.orderId;

      if (paymentStatus === "SUCCESS") {
        setStatus("SUCCESS");

        // Clear cart after successful payment
        if (userId) {
          await api.delete(`/api/cart/clear/${userId}`);
        }

        // Redirect to order confirmation
        setTimeout(() => {
          if (orderId) {
            navigate(`/order-confirmation/${orderId}`);
          } else {
            navigate("/");
          }
        }, 2000);
      } 
      else if (paymentStatus === "FAILED") {
        setStatus("FAILED");
      } 
      else {
        setStatus("PENDING");
      }
    } catch (error) {
      console.error("Payment status error:", error);
      setStatus("FAILED");
    } finally {
      setLoading(false);
    }
  }, [merchantTransactionId, searchParams, navigate, userId]);

  /* ================= ON LOAD ================= */

  useEffect(() => {
    checkPayment();
  }, [checkPayment]);

  /* ================= UI ================= */

  return (
    <div className="container text-center py-5">
      {loading && (
        <>
          <h4>Checking Payment Status...</h4>
          <p>Please wait</p>
        </>
      )}

      {!loading && status === "SUCCESS" && (
        <>
          <h2 className="text-success">Payment Successful 🎉</h2>
          <p>Redirecting to order confirmation...</p>
        </>
      )}

      {!loading && status === "FAILED" && (
        <>
          <h2 className="text-danger">Payment Failed ❌</h2>
          <p className="text-muted">
            If amount was deducted, it will be refunded automatically.
          </p>
          <button
            className="btn btn-primary mt-3"
            onClick={() => navigate("/ShopCart")}
          >
            Try Again
          </button>
        </>
      )}

      {!loading && status === "PENDING" && (
        <>
          <h2 className="text-warning">Payment Pending ⏳</h2>
          <p>Waiting for confirmation from bank</p>
          <button
            className="btn btn-outline-primary mt-3"
            onClick={checkPayment}
          >
            Refresh Status
          </button>
        </>
      )}
    </div>
  );
};

export default Payment;